export default "__VITE_ASSET__4XHep_L4__"